import { OperationType, Transaction, TransactionStatus } from '../../../domain/transaction';
import { useEffect, useState } from 'react';
import { chartUtilService, groupTransactionModel } from '../util/ChartUtil';
import { TransactionTypeChart } from '../enum/Dashboard.enum';
const defaultStatSalesNet = {
  salesNet: 0,
  totalTransactions: 0,
}

export const useTransactionDonutChartData = (transactions: Transaction[]) => {
  const [chartMap, setChartMap] = useState<Map<TransactionTypeChart, {}>>(new Map())
  const [statSalesNet, setStatSalesNet] = useState(defaultStatSalesNet)

  useEffect(() => {
     if (!transactions.length) {
       setChartMap(new Map())
       setStatSalesNet(defaultStatSalesNet)
       return
     }
    const processData = () => {
      const statSalesNet = {
        salesNet: 0,
        totalTransactions: 0,
      }
      const dataForGroup: groupTransactionModel[] = [
        TransactionTypeChart.PAYMENT_METHOD,
        TransactionTypeChart.STATUS,
        TransactionTypeChart.OPERATION_TYPE,
        TransactionTypeChart.CARD_BRAND,
      ].map(key => ({
        key,
        groupMap: new Map(),
        labelMap: new Map(),
        totalTransactions: 0
      }));

      transactions.forEach((transaction: Transaction) => {
        dataForGroup.forEach(model => {
          chartUtilService.loadDonutChartData(transaction, model)
        });

        if (transaction.status === TransactionStatus.approved) {
          if(transaction.operation_type === OperationType.payment) {
            statSalesNet.totalTransactions += 1
          } else {
            statSalesNet.totalTransactions -= 1
          }
          statSalesNet.salesNet += transaction.gross_amount ?? 0
        }
      })


      const chartMap: Map<TransactionTypeChart, {}> =
        chartUtilService.getDonutChartData(dataForGroup)

      setChartMap(chartMap)
      setStatSalesNet(statSalesNet)
    };

    processData()
  }, [transactions])

  return {
    donutCharts: [
      { data: chartMap.get(TransactionTypeChart.PAYMENT_METHOD) ?? [], title: 'Método de pago' },
      { data: chartMap.get(TransactionTypeChart.CARD_BRAND) ?? [], title: 'Marca' },
      { data: chartMap.get(TransactionTypeChart.STATUS) ?? [], title: 'Estado' },
      { data: chartMap.get(TransactionTypeChart.OPERATION_TYPE) ?? [], title: 'Tipo' },
    ],
    statSalesNet,
  };
};
